import React from "react";
import { useTranslation } from "react-i18next";
import { ImageConstant, KeyConstant, LangConstant, PathConstant, SystemConstant } from "const";
import { OTPVerify } from "components";
import { AuthUtils, StorageUtils } from "utils";
import { useLogin, useSmartOTP } from "hooks";

const SmartOTP = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_COMMON);
  const { login } = useLogin();
  const { otp, verifyOtp, handleChangeOtp, handleReCountTimer } = useSmartOTP();

  const title = getLabel(LangConstant.OBJ_ROUTER_TITLE, { returnObjects: true });

  const handleResendOtp = () => {
    const form = StorageUtils.getStoreData(KeyConstant.KEY_PRE_AUTH);
    login({ ...form, password: window.atob(form.password) });
    handleReCountTimer();
  };

  const handleSubmit = () => {
    const form = StorageUtils.getStoreData(KeyConstant.KEY_PRE_AUTH);
    const payload = { ...form, ...otp };
    verifyOtp(payload);
  };

  const isDisableButton = !Boolean(otp.code.length === SystemConstant.SMART_OTP_CONFIGS.length && otp.retry > 0);

  return (
    <div className="row g-0" style={{ height: "100vh" }}>
      <div
        className="col-12 col-md-6 col-lg-5 col-xl-4 d-flex align-items-center"
        style={{ padding: "0 80px" }}
      >
        <div style={{ maxWidth: "400px", margin: "0 auto", width: "100%" }}>
          {otp.blocked ? (
            <div className="d-flex justify-content-center flex-column">
              <p className="text-center text-danger" style={{ whiteSpace: "pre-line" }}>
                {getLabel(LangConstant.TXT_SMART_OTP_BLOCK)}
              </p>
              <button
                className="btn btn-primary btn-sm"
                style={{ margin: "16px auto" }}
                onClick={AuthUtils.handleLogout}
              >
                OK
              </button>
            </div>
          ) : (
            <div>
              <OTPVerify
                TitleProps={{
                  title: getLabel(title[PathConstant.VERIFY_SMART_OTP]),
                  content: getLabel(LangConstant.TXT_VERIFY_SMART_OTP_CONTENT),
                }}
                InputProps={{
                  disabled: otp.retry === 0,
                  otpLength: SystemConstant.SMART_OTP_CONFIGS.length,
                  errorContent: otp.error,
                  onChange: handleChangeOtp,
                }}
                ActionProps={{
                  disabled: otp.retry === 0,
                  startCountDownNumber: otp.resentOtpTrigger,
                  onLogout: AuthUtils.handleLogout,
                  onResendOtp: handleResendOtp,
                }}
              />
              <button
                className="btn btn-primary w-100 btn-lg"
                disabled={isDisableButton}
                style={{ marginTop: "16px" }}
                onClick={handleSubmit}
              >
                {getLabel(LangConstant.TXT_VERIFY_OTP)}
              </button>
            </div>
          )}
        </div>
      </div>
      <div
        className="col-12 col-md-6 col-lg-7 col-xl-8 d-none d-md-flex align-items-center justify-content-center"
        style={{ backgroundColor: "var(--tblr-bg-surface-secondary)", overflow: "hidden" }}
      >
        <img
          src={ImageConstant.LoginBackgroundImage}
          alt="Login Background"
          style={{ maxWidth: 634, maxHeight: 472, width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
};

export default SmartOTP;
